import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const DefinitiveMitur = () => {
  const {
    validationDocuments: { final_confotur }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3} rowGap={1}>
      <Grid item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_definitive_confotur}
          label="Definitivo CONFOTUR"
          maxSize={3}
          minSize={0}
          disabled={final_confotur?.disabled}
          typeKey={CValidationDocumentKeys.FinalConfotur}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_file_definitive_confotur}
          label="Fecha de emisión"
          disabled={final_confotur?.disabled}
        />
      </Grid>
    </Grid>
  );
};

export default DefinitiveMitur;
